import styled from "styled-components";
import styles from "../controlBar/ControlBar.module.css";
import { useTheme } from "../../middleware/ThemeContext";

const ShortcutButton = ({
    icon,
    label,
    onClick,
    iconPostions = "left",
    textColor,
    height,
    fontSize,
    fontWeight
}: {
    // icon: string;
    icon: React.ReactNode;
    label: string;
    onClick?: () => void;
    iconPostions?: string;
    textColor?: string;
    height?: string;
    fontSize?: string;
    fontWeight?: number
}) => {
    const { theme } = useTheme();
    textColor = textColor || theme.colors.topBarsColorText
    return (
        <ButtonShortcut className={styles.shortcutButton} theme={theme} onClick={onClick} $height={height}>
            {/* <img src={icon} alt={label} className={styles.icon} /> */}
            {iconPostions === "left" && <>{icon}</>}
            {label ? <span className={styles.label} style={{ color: textColor, fontSize: fontSize, fontWeight: fontWeight }}>{label}</span> : null}
            {iconPostions === "right" && <>{icon}</>}
        </ButtonShortcut>
    );
}

const ButtonShortcut = styled('button')<{ $height?: string }>(({ theme, $height }) => ({
    height: $height || "40px",
    gap: 8,
    '&:hover': {
        backgroundColor: theme.colors.topBarsColorHover,
    },
}));

export default ShortcutButton